<!--Filter/Refresh Menu-->
<!--Options-->
<div class="OptionDiv">
	<label>Facility:</label>
	<p-dropdown
		class="LeftMarginSmall"
		[disabled]="IsLoading() == true"
		[options]="lstFacility"
		[(ngModel)]="Facility"
		optionLabel="FacilityName"
		[filter]="true"
		filterBy="FacilityName"
		[showClear]="false"
		placeholder="Select a Facility"
	>
		<ng-template pTemplate="selectedItem">
			<div *ngIf="Facility">
				<div class="form-control NoBorder" style="text-align: left">
					{{ Facility.FacilityName }}
				</div>
			</div>
		</ng-template>
		<ng-template let-FacilityItem pTemplate="item">
			<div>
				<div class="form-control NoBorder" style="text-align: left">
					{{ FacilityItem.FacilityName }}
				</div>
			</div>
		</ng-template>
	</p-dropdown>
</div>

<div class="ButtonDiv">
	<button [disabled]="IsLoading() == true" class="btn btn-primary" style="margin: 0px" (click)="onRefresh()">Refresh</button>
	<button [disabled]="IsLoading() == true" class="btn btn-primary" style="margin: 0px 0px 0px 5px" (click)="onPrint()">Print</button>
</div>

<!--Display Data-->
<div class="TopMargin">
	<p-table
		#mydt
		[value]="lstPerson"
		[loading]="IsLoading() == true"
		[paginator]="true"
		[(rows)]="pagerows"
		[(first)]="pagefirst"
		[showCurrentPageReport]="true"
		[resizableColumns]="false"
		sortMode="multiple"
		styleClass="p-datatable-striped"
		selectionMode="single"
		[(selection)]="SelectedPerson"
		dataKey="VisitorPassID"
		currentPageReportTemplate="Showing {first} to {last} of {totalRecords} entries"
		[rowsPerPageOptions]="[5, 10, 25, 50]"
	>
		<!--Headers-->
		<ng-template pTemplate="header">
			<!--Filter or Select from Dropdown-->
			<tr>
				<th class="ImageCol"></th>

				<!--INSERT CUSTOM FILTERS HERE-->

				<!--FirstName-->
				<th>
					<p-columnFilter type="text" field="FirstName" matchMode="contains" [showMenu]="true"></p-columnFilter>
				</th>

				<!--LastName-->
				<th>
					<p-columnFilter type="text" field="LastName" matchMode="contains" [showMenu]="true"></p-columnFilter>
				</th>

				<!--LastEntryDT-->
				<th>
					<!-- <p-columnFilter type="text" field="LastEntryDT" matchMode="contains" [showMenu]="true"></p-columnFilter> -->
				</th>

				<!--LastFacilityName-->
				<th>
					<p-columnFilter field="LastFacilityName" matchMode="equals" [showMenu]="false">
						<ng-template pTemplate="filter" let-value let-filter="filterCallback">
							<p-dropdown
								#filterLastFacilityName
								[ngModel]="value"
								[options]="lstLastFacilityName"
								(onChange)="filter($event.value)"
								placeholder="Any"
								[showClear]="true"
							>
								<ng-template let-value pTemplate="item">
									<span>{{ value }}</span>
								</ng-template>
							</p-dropdown>
						</ng-template>
					</p-columnFilter>
				</th>

				<!--LastFacilityLocationName-->
				<th>
					<p-columnFilter field="LastFacilityLocationName" matchMode="equals" [showMenu]="false">
						<ng-template pTemplate="filter" let-value let-filter="filterCallback">
							<p-dropdown
								#filterLastFacilityLocationName
								[ngModel]="value"
								[options]="lstLastFacilityLocationName"
								(onChange)="filter($event.value)"
								placeholder="Any"
								[showClear]="true"
							>
								<ng-template let-value pTemplate="item">
									<span>{{ value }}</span>
								</ng-template>
							</p-dropdown>
						</ng-template>
					</p-columnFilter>
				</th>

				<!--LastScanStation-->
				<th>
					<p-columnFilter field="LastScanStation" matchMode="equals" [showMenu]="false">
						<ng-template pTemplate="filter" let-value let-filter="filterCallback">
							<p-dropdown
								#filterLastScanStation
								[ngModel]="value"
								[options]="lstLastScanStation"
								(onChange)="filter($event.value)"
								placeholder="Any"
								[showClear]="true"
							>
								<ng-template let-value pTemplate="item">
									<span>{{ value }}</span>
								</ng-template>
							</p-dropdown>
						</ng-template>
					</p-columnFilter>
				</th>

				<!--Destination-->
				<th>
					<p-columnFilter field="Destination" matchMode="equals" [showMenu]="false">
						<ng-template pTemplate="filter" let-value let-filter="filterCallback">
							<p-dropdown
								#filterDestination
								[ngModel]="value"
								[options]="lstDestination"
								(onChange)="filter($event.value)"
								placeholder="Any"
								[showClear]="true"
							>
								<ng-template let-value pTemplate="item">
									<span>{{ value }}</span>
								</ng-template>
							</p-dropdown>
						</ng-template>
					</p-columnFilter>
				</th>

				<!--VisitorReasonDesc-->
				<th>
					<p-columnFilter field="VisitorReasonDesc" matchMode="equals" [showMenu]="false">
						<ng-template pTemplate="filter" let-value let-filter="filterCallback">
							<p-dropdown
								#filterVisitorReasonDesc
								[ngModel]="value"
								[options]="lstVisitorReasonDesc"
								(onChange)="filter($event.value)"
								placeholder="Any"
								[showClear]="true"
							>
								<ng-template let-value pTemplate="item">
									<span>{{ value }}</span>
								</ng-template>
							</p-dropdown>
						</ng-template>
					</p-columnFilter>
				</th>

				<!--PassComment-->
				<th>
					<p-columnFilter type="text" field="PassComment" matchMode="contains" [showMenu]="true"></p-columnFilter>
				</th>

				<!--WaitingForVerificationDesc-->
				<th>
					<p-columnFilter field="WaitingForVerificationDesc" matchMode="equals" [showMenu]="false">
						<ng-template pTemplate="filter" let-value let-filter="filterCallback">
							<p-dropdown
								#filterWaitingForVerificationDesc
								[ngModel]="value"
								[options]="lstWaitingForVerificationDesc"
								(onChange)="filter($event.value)"
								placeholder="Any"
								[showClear]="true"
							>
								<ng-template let-value pTemplate="item">
									<span>{{ value }}</span>
								</ng-template>
							</p-dropdown>
						</ng-template>
					</p-columnFilter>
				</th>
			</tr>

			<!--Column Names-->
			<tr style="height: 4rem">
				<th class="ImageCol"></th>

				<!--INSERT CUSTOM COLUMNS HERE-->
				<th pSortableColumn="FirstName">First Name<p-sortIcon field="FirstName"></p-sortIcon></th>
				<th pSortableColumn="LastName">Last Name<p-sortIcon field="LastName"></p-sortIcon></th>
				<th pSortableColumn="LastEntryDT">Last Entry<p-sortIcon field="LastEntryDT"></p-sortIcon></th>
				<th pSortableColumn="LastFacilityName">Last Facility<p-sortIcon field="LastFacilityName"></p-sortIcon></th>
				<th pSortableColumn="LastFacilityLocationName">Last Location<p-sortIcon field="LastFacilityLocationName"></p-sortIcon></th>
				<th pSortableColumn="LastScanStation">Station<p-sortIcon field="LastScanStation"></p-sortIcon></th>
				<th pSortableColumn="Destination">Destination<p-sortIcon field="Destination"></p-sortIcon></th>
				<th pSortableColumn="VisitorReasonDesc">Reason<p-sortIcon field="VisitorReasonDesc"></p-sortIcon></th>
				<th pSortableColumn="PassComment">Comments<p-sortIcon field="PassComment"></p-sortIcon></th>
				<th pSortableColumn="WaitingForVerificationDesc">Waiting for Verification<p-sortIcon field="WaitingForVerificationDesc"></p-sortIcon></th>
			</tr>
		</ng-template>

		<!--Data-->
		<ng-template pTemplate="body" let-Person>
			<tr [pSelectableRow]="Person" (dblclick)="onRowDblClick(Person)">
				<td class="ImageCol">
					<a [id]="'Link' + Person.VisitorPassDetailID" style="display: none" [routerLink]="Person.RouterLink" target="_blank"></a>
					<img class="VisitorImage" [src]="GetPhotoData(Person.VisitorPassID)" />
				</td>

				<td *ngFor="let col of cols" style="font-weight: bold; text-overflow: ellipsis; word-break: break-word">
					{{ Person[col.field] }}
				</td>

				<td
					style="font-weight: bold; text-overflow: ellipsis; word-break: break-word"
					[style.color]="Person.WaitingForVerification == true ? 'Red' : 'Black'"
				>
					{{ Person.WaitingForVerificationDesc }}
				</td>
			</tr>
		</ng-template>
	</p-table>
</div>

<!--Error Message-->
<div class="TopMargin">
	<div name="errorMessage" *ngIf="errorMessage" class="alert alert-danger">
		{{ errorMessage }}
	</div>
</div>
